<rotec-file-upload-v2 (filesChange)="uploadFiles($event)"> </rotec-file-upload-v2>
@for (taskDoc of taskDocuments$ | async; track taskDoc) {
  <div class="file-row" [class.disabled]="documentsLoading" (click)="openFile(taskDoc.id)">
    <rotec-icon-v2 svgIcon="file"></rotec-icon-v2>
    <span class="file-name">
      {{ taskDoc.name }}
    </span>
    <rotec-icon-v2
      svgIcon="download"
      (click)="downloadFile(taskDoc.id, taskDoc.name, $event)"
    ></rotec-icon-v2>
    <rotec-icon-v2
      [class.disabled]="loading"
      svgIcon="trash"
      (click)="deleteFile(taskDoc.id, $event)"
    ></rotec-icon-v2>
  </div>
}

@if (loading) {
  <rotec-spinner></rotec-spinner>
}
